import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Container = styled.div`
  padding: 10px 0;
  margin: 5px 20px;
  padding-left: 10px;
  background-color: ${colors.grayExtraLight};
`
export const Title = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: ${colors.black};
  padding-right: 10px;
`

export const Subtitle = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: ${colors.gray};
`
